import { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { DeploymentForm } from '@/components/deployments/form';
import { usePermissions } from '@/hooks/use-permissions';
import { getDeploymentRuleQueryOptions } from '@/queries/deployments';
import { useWorkspaceNavigate } from '@/utils/routes';

function DeploymentPage() {
  const { id } = useParams();
  const { canManageDeploymentRules } = usePermissions();
  const navigate = useWorkspaceNavigate();
  const { data: deploymentRule, isFetching } = useQuery(getDeploymentRuleQueryOptions({ id }));

  // Members can view the register but not the edit form — bounce them back.
  useEffect(() => {
    if (!canManageDeploymentRules) {
      navigate('/deployments', { replace: true });
    }
  }, [canManageDeploymentRules, navigate]);

  if (!canManageDeploymentRules) return null;

  return <DeploymentForm deploymentRule={deploymentRule} isLoading={isFetching} />;
}

export default DeploymentPage;
